<template>
    <div id="app"
        class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
        <HeadNav :selectedLanguage="selectedLanguage" page="blog-7" :gotodownload="gotodownload" :apk="apk" />

        <div id="page" class="site grid-container container hfeed">
            <div class="markdown-content">
                <h1><strong>How to Schedule Messages in GB WhatsApp</strong></h1>

                <img src="@/assets/blog-2.webp" alt="How to Schedule Messages in GB WhatsApp">

                <p>Need to send a WhatsApp message later but don't want to rely on your memory?
                    <a href="https://gbfreeapk.com/"><strong>GB WhatsApp</strong></a> includes a
                    <strong>Message Scheduler</strong> in some builds, allowing you to write a message now and choose
                    when it should be sent.
                </p>

                <p>It can be useful for birthday wishes, reminders, follow-up messages, or anything else you already
                    know you need to send at a specific time.</p>

                <p>The exact menu can vary between GB WhatsApp versions, so don't worry if your screen looks slightly
                    different from the steps below.</p>

                <h2>How to Schedule a Message in GB WhatsApp</h2>

                <p>Try these steps first:</p>

                <ol>
                    <li>Open <strong>GB WhatsApp</strong> and enter the chat where you want to send the message.</li>
                    <li>Type the message normally.</li>
                    <li>Instead of sending it immediately, look for <strong>Schedule Message</strong>,
                        <strong>Message Scheduler</strong>, or a clock icon.
                    </li>
                    <li>Select the date and time when you want the message to be sent.</li>
                    <li>Check the recipient, message, date, and time.</li>
                    <li>Tap <strong>Schedule</strong>, <strong>Save</strong>, or the equivalent confirmation button.
                    </li>
                </ol>

                <p>Some versions open the scheduler from the three-dot menu inside the chat, while others may show it
                    after pressing and holding the send button.</p>

                <p>Once saved, the message should remain in the scheduled queue until the selected time.</p>

                <h2>Can't Find the Schedule Option?</h2>

                <p>This is one of the most common problems.</p>

                <p>First, open <strong>GB Settings</strong> and look for <strong>Message Scheduler</strong> or
                    <strong>Scheduled Messages</strong>. Some versions put the feature there instead of directly inside
                    a conversation. Other builds place it in the chat's three-dot menu.
                </p>

                <p>If you still cannot find it, your particular GB WhatsApp build may not include the feature or may use
                    a different menu name.</p>

                <p>Don't install another APK just because one feature is missing without first checking your current
                    version.</p>

                <h2>How to Check a Scheduled Message</h2>

                <p>After creating a schedule, look for <strong>Scheduled Messages</strong>,
                    <strong>Message Scheduler</strong>, or a similar section in GB WhatsApp.
                </p>

                <p>Depending on the build, you may be able to see:</p>

                <ul>
                    <li>The person or group receiving the message</li>
                    <li>The scheduled date and time</li>
                    <li>The message content</li>
                    <li>Options to edit or cancel it</li>
                </ul>

                <p>Some versions show scheduled messages directly inside the chat, while others keep them in a separate
                    scheduler list.</p>

                <h2>How to Cancel a Scheduled Message</h2>

                <p>Changed your mind?</p>

                <p>Open the scheduler and find the message you no longer want to send. Select it and look for
                    <strong>Delete</strong>, <strong>Cancel</strong>, or a similar option.
                </p>

                <p>If your version allows editing, you can also change the message or schedule it for another time
                    instead.</p>

                <p>Always check the scheduler before the delivery time if the message is important.</p>

                <h2>Why Didn't My Scheduled Message Send?</h2>

                <p>If a scheduled message stays pending, check these things first:</p>

                <p><strong>Internet connection:</strong><br>
                    The app needs to be able to communicate with WhatsApp when it is time to send the message.</p>

                <p><strong>Background restrictions:</strong><br>
                    Android may restrict GB WhatsApp from running in the background. Check your phone's battery settings
                    if scheduled messages repeatedly fail.</p>

                <p><strong>Correct date and time:</strong><br>
                    Make sure your phone's clock and time zone are correct.</p>

                <p><strong>App permissions:</strong><br>
                    If your phone aggressively closes background apps, GB WhatsApp may not get a chance to process the
                    scheduled task.</p>

                <p><strong>Version-specific problems:</strong><br>
                    Schedulers are modified features, so their behavior can vary between GB WhatsApp builds.</p>

                <h2>Can You Schedule Repeating Messages?</h2>

                <p>Some GB WhatsApp versions include a <strong>Repeat</strong> option for scheduled messages, such as
                    daily, weekly, or monthly schedules. Other builds only support one-time messages.</p>

                <p>If you see a <strong>Repeat</strong>, <strong>Recurring</strong>, or similar option when creating a
                    schedule, you can use it to set the frequency. If there is no such option, your current build may
                    only support one-time scheduling.</p>

                <h2>A Simple Way to Test the Scheduler</h2>

                <p>Before scheduling an important birthday message or work reminder, test the feature with a message
                    scheduled a few minutes ahead.</p>

                <p>This lets you check whether the scheduler works correctly on your phone and whether Android is
                    allowing GB WhatsApp to run in the background.</p>

                <p>Once the test arrives successfully, you can use the scheduler for messages that need to go out at a
                    specific time.</p>
            </div>
        </div>

        <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
            Download GBWhatsapp APK
        </div>
    </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/blog/blogspc.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
    name: 'Blog7',
    components: {
        HeadNav,
    },
    data() {
        return {
            pageName: 'blog-7',
            selectedLanguage: 'en',
            showapk: false,
            apk: null,
            from: 'gb',
            filename: 'gb',
        };
    },
    mounted() {
        this.from = this.$global.GetQueryString('from') || this.from;
        this.filename = this.$global.GetQueryString('filename') || this.filename;
        console.log(this.$global.GetQueryString('from'));
        if (this.$global.GetQueryString('from')) {
            this.getAPK();
        } else {
            this.getOfficalApk();
        }
    },
    methods: {
        goto(name) {
            this.$router.push({
                name: `${name}`
            });
        },
        downloadfrom(reason) {
            this.download();
            this.$logEvent(`download_from_${reason}`, 'download');
        },
        getAPK() {
            this.$server
                .getAPPInfo({
                    promotionChannel: this.from,
                    promotionName: this.filename,
                })
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.apk = res.data.apk;
                    } else {
                        this.apk = process.env.VUE_APP_GBLINK;
                    }
                });
        },
        getOfficalApk(type = 1, domain = null, appname = null) {
            this.$server
                .getOfficalApk({
                    domain: domain || 'gbwhatsapp.chat',
                    appName: appname || 'GB_gbwhatsapp.chat',
                })
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        if (type == 1) {
                            this.apk = res.data.apk;
                        }
                        this.lastupdate = res.data.promotion.updateTime;
                        this.votes = res.data.promotion.totalCount;
                        this.rating = res.data.promotion.score;
                        console.log('apk getted');
                    } else {
                        this.apk = process.env.VUE_APP_GBLINK;
                    }
                });
        },
        gotodownload() {
            console.log(this.apk);
            if (this.apk) {
                this.$global.download(this.apk);
            }
        },
        jump(url) {
            window.location.href = url;
        },
        gotoHome(page) {
            this.$router.push({
                name: `${this.selectedLanguage}-${page}`
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.markdown-content {
    padding: 20px;
    line-height: 1.6;
    margin: 20px auto;
    max-width: 1000px;
    background: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
}

.markdown-content h1 {
    font-size: 2em;
    margin: 0.67em 0;
    border-bottom: 2px solid #eee;
    padding-bottom: 0.3em;
    color: #2d3748;
    text-align: center;
}

.markdown-content h2 {
    font-size: 1.5em;
    margin: 0.75em 0;
    margin-top: 40px;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.3em;
    color: #2d3748;
}

.markdown-content h3 {
    font-size: 1.25em;
    margin: 0.83em 0;
    margin-top: 40px;
    color: #2d3748;
}

.markdown-content h4 {
    font-size: 1em;
    margin: 1em 0;
    color: #2d3748;
}

.markdown-content p {
    margin: 1em 0;
}

.markdown-content ul,
.markdown-content ol {
    margin: 1em 0;
    padding-left: 2em;
}

.markdown-content li {
    margin: 0.5em 0;
}

.markdown-content img {
    width: 100%;
    height: auto;
    border-radius: 4px;
    margin: 1em 0;
}

.markdown-content a {
    color: #667eea;
    text-decoration: none;
}

.markdown-content a:hover {
    text-decoration: underline;
}

.markdown-content strong {
    font-weight: 700;
}

.markdown-content em {
    font-style: italic;
}
</style>
